import React from 'react';
import { Select, Typography } from 'antd';
import { useBudgetScenarios } from '../../../../../hooks/useBudgetScenarios';
import { budgetScenarioOptions } from '../../../../../utils/budgetScenarios';

const { Text } = Typography;

/**
 * Cenário do orçamento = página de cenário do Planejamento. Grava o id da página em budgetValueType;
 * configurações antigas (valorMedio/valorPessimista/valorOtimista) aparecem como a página migrada.
 */
const BudgetScenarioSelect = ({ syncId, value, onChange }) => {
  const { scenarios, loading } = useBudgetScenarios(syncId);
  const { options, value: selected } = budgetScenarioOptions(scenarios, value);

  return (
    <div>
      <Text strong>Cenário do orçamento</Text>
      <Select
        getPopupContainer={(trigger) => trigger.parentNode}
        style={{ width: '100%', marginTop: 4 }}
        loading={loading}
        value={selected}
        onChange={onChange}
        options={options}
        placeholder={loading ? 'Carregando cenários…' : 'Nenhum cenário nesta empresa'}
        notFoundContent="Nenhum cenário de orçamento nesta empresa"
      />
      <Text type="secondary" style={{ fontSize: '12px', marginTop: 4, display: 'block' }}>
        Os cenários são criados e renomeados em Planejamento › Simulador.
      </Text>
    </div>
  );
};

export default BudgetScenarioSelect;
